import Vue from 'vue';
import Router from 'vue-router';
import AuthLayout from '@/layouts/Auth';
import MainLayout from '@/layouts/Main';
/* import store from '@/store'; */
import { i18n } from './localization';
// import reports from '@/views/main-menu/reports';
import PublicLayout from '@/layouts/Public';
import CustomPublicLayout from '@/layouts/CustomPublic';
import CustomLayout from '@/layouts/Custom';
Vue.use(Router);
const router = new Router({
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/',
            redirect: '/home' /* Set Default Page */,
            component: MainLayout,
            meta: {
                authRequired: true,
                hidden: true,
            },
            children: [
                // คู่มือ
                {
                    path: '/manual',
                    meta: {
                        title: i18n.tc('Manual'),
                    },
                    component: () => import('./views/manual'),
                },
                // Dashboards
                {
                    path: '/dashboard',
                    meta: {
                        title: 'Dashboard',
                    },
                    component: () => import('./views/dashboard'),
                },
                /* {
                  path: '/dashboard/beta',
                  meta: {
                    title: 'Dashboard Beta',
                  },
                  component: () => import('./views/dashboard/beta'),
                },
                {
                  path: '/dashboard/crypto',
                  meta: {
                    title: 'Dashboard Crypto',
                  },
                  component: () => import('./views/dashboard/crypto'),
                },
                {
                  path: '/dashboard/gamma',
                  meta: {
                    title: 'Dashboard Gamma',
                  },
                  component: () => import('./views/dashboard/gamma'),
                }, */
                // Ecommerce
                {
                    path: '/ecommerce/dashboard',
                    meta: {
                        title: 'Ecommerce Dashboard',
                    },
                    component: () => import('./views/ecommerce/dashboard'),
                },
                {
                    path: '/ecommerce/orders',
                    meta: {
                        title: 'Ecommerce Orders',
                    },
                    component: () => import('./views/ecommerce/orders'),
                },
                {
                    path: '/ecommerce/product-catalog',
                    meta: {
                        title: 'Ecommerce Product Catalog',
                    },
                    component: () => import('./views/ecommerce/product-catalog'),
                },
                {
                    path: '/ecommerce/product-details',
                    meta: {
                        title: 'Ecommerce Product Details',
                    },
                    component: () => import('./views/ecommerce/product-details'),
                },
                {
                    path: '/ecommerce/cart',
                    meta: {
                        title: 'Ecommerce Cart',
                    },
                    component: () => import('./views/ecommerce/cart'),
                },
                // Widgets
                {
                    path: '/widgets/general',
                    meta: {
                        title: 'Widgets / General',
                    },
                    component: () => import('./views/widgets/general'),
                },
                {
                    path: '/widgets/lists',
                    meta: {
                        title: 'Widgets / Lists',
                    },
                    component: () => import('./views/widgets/lists'),
                },
                {
                    path: '/widgets/tables',
                    meta: {
                        title: 'Widgets / Tables',
                    },
                    component: () => import('./views/widgets/tables'),
                },
                {
                    path: '/widgets/charts',
                    meta: {
                        title: 'Widgets / Charts',
                    },
                    component: () => import('./views/widgets/charts'),
                },
                // Apps
                {
                    path: '/apps/calendar',
                    meta: {
                        title: 'Apps / Calendar',
                    },
                    component: () => import('./views/apps/calendar'),
                },
                {
                    path: '/apps/digitalocean-create',
                    meta: {
                        title: 'Apps / DigitalOcean Create',
                    },
                    component: () => import('./views/apps/digitalocean-create'),
                },
                {
                    path: '/apps/digitalocean-droplets',
                    meta: {
                        title: 'Apps / DigitalOcean Droplets',
                    },
                    component: () => import('./views/apps/digitalocean-droplets'),
                },
                {
                    path: '/apps/gallery',
                    meta: {
                        title: 'Apps / Gallery',
                    },
                    component: () => import('./views/apps/gallery'),
                },
                {
                    path: '/apps/github-discuss',
                    meta: {
                        title: 'Apps / GitHub Discuss',
                    },
                    component: () => import('./views/apps/github-discuss'),
                },
                {
                    path: '/apps/github-explore',
                    meta: {
                        title: 'Apps / GitHub Explore',
                    },
                    component: () => import('./views/apps/github-explore'),
                },
                {
                    path: '/apps/google-analytics',
                    meta: {
                        title: 'Apps / Google Analytics',
                    },
                    component: () => import('./views/apps/google-analytics'),
                },
                {
                    path: '/apps/helpdesk-dashboard',
                    meta: {
                        title: 'Apps / Helpdesk Dashboard',
                    },
                    component: () => import('./views/apps/helpdesk-dashboard'),
                },
                {
                    path: '/apps/jira-agile-board',
                    meta: {
                        title: 'Apps / Jira Agile Board',
                    },
                    component: () => import('./views/apps/jira-agile-board'),
                },
                {
                    path: '/apps/jira-dashboard',
                    meta: {
                        title: 'Apps / Jira Dashboard',
                    },
                    component: () => import('./views/apps/jira-dashboard'),
                },
                {
                    path: '/apps/mail',
                    meta: {
                        title: 'Apps / Mail',
                    },
                    component: () => import('./views/apps/mail'),
                },
                {
                    path: '/apps/messaging',
                    meta: {
                        title: 'Apps / Mesagging',
                    },
                    component: () => import('./views/apps/messaging'),
                },
                {
                    path: '/apps/profile',
                    meta: {
                        title: 'Apps / Profile',
                    },
                    component: () => import('./views/apps/profile'),
                },
                {
                    path: '/apps/todoist-list',
                    meta: {
                        title: 'Apps / Todoist List',
                    },
                    component: () => import('./views/apps/todoist-list'),
                },
                {
                    path: '/apps/wordpress-add',
                    meta: {
                        title: 'Apps / Wordpress Add',
                    },
                    component: () => import('./views/apps/wordpress-add'),
                },
                {
                    path: '/apps/wordpress-post',
                    meta: {
                        title: 'Apps / Wordpress Post',
                    },
                    component: () => import('./views/apps/wordpress-post'),
                },
                {
                    path: '/apps/wordpress-posts',
                    meta: {
                        title: 'Apps / Wordpress Posts',
                    },
                    component: () => import('./views/apps/wordpress-posts'),
                },
                // Cards
                {
                    path: '/cards/basic-cards',
                    meta: {
                        title: 'Cards / Basic',
                    },
                    component: () => import('./views/cards/basic-cards'),
                },
                {
                    path: '/cards/tabbed-cards',
                    meta: {
                        title: 'Cards / Tabbed',
                    },
                    component: () => import('./views/cards/tabbed-cards'),
                },
                // UI Kits
                {
                    path: '/ui-kits/bootstrap',
                    meta: {
                        title: 'UI Kit / Bootstrap',
                    },
                    component: () => import('./views/ui-kits/bootstrap'),
                },
                {
                    path: '/ui-kits/antd',
                    meta: {
                        title: 'UI Kit / Ant Design',
                    },
                    component: () => import('./views/ui-kits/antd'),
                },
                // Tables
                {
                    path: '/tables/bootstrap',
                    meta: {
                        title: 'Tables / Bootstrap',
                    },
                    component: () => import('./views/tables/bootstrap'),
                },
                {
                    path: '/tables/antd',
                    meta: {
                        title: 'Tables / Ant Design',
                    },
                    component: () => import('./views/tables/antd'),
                },
                // Charts
                {
                    path: '/charts/chartistjs',
                    meta: {
                        title: 'Charts / Chartist.js',
                    },
                    component: () => import('./views/charts/chartistjs'),
                },
                {
                    path: '/charts/chartjs',
                    meta: {
                        title: 'Charts / Chart.js',
                    },
                    component: () => import('./views/charts/chartjs'),
                },
                {
                    path: '/charts/c3',
                    meta: {
                        title: 'Charts / C3 Charts',
                    },
                    component: () => import('./views/charts/c3'),
                },
                // Icons
                {
                    path: '/icons/feather-icons',
                    meta: {
                        title: 'Icons / Feather',
                    },
                    component: () => import('./views/icons/feather-icons'),
                },
                {
                    path: '/icons/fontawesome',
                    meta: {
                        title: 'Icons / Fontawesome',
                    },
                    component: () => import('./views/icons/fontawesome'),
                },
                {
                    path: '/icons/linearicons-free',
                    meta: {
                        title: 'Icons / Linearicons Free',
                    },
                    component: () => import('./views/icons/linearicons-free'),
                },
                {
                    path: '/icons/icomoon-free',
                    meta: {
                        title: 'Icons / Icomoon Free',
                    },
                    component: () => import('./views/icons/icomoon-free'),
                },
                // Advanced
                {
                    path: '/advanced/form-examples',
                    meta: {
                        title: 'Advanced / Form Examples',
                    },
                    component: () => import('./views/advanced/form-examples'),
                },
                {
                    path: '/advanced/email-templates',
                    meta: {
                        title: 'Advanced / Email Templates',
                    },
                    component: () => import('./views/advanced/email-templates'),
                },
                {
                    path: '/advanced/utilities',
                    meta: {
                        title: 'Advanced / Utilities',
                    },
                    component: () => import('./views/advanced/utilities'),
                },
                {
                    path: '/advanced/grid',
                    meta: {
                        title: 'Advanced / Grid',
                    },
                    component: () => import('./views/advanced/grid'),
                },
                {
                    path: '/advanced/typography',
                    meta: {
                        title: 'Advanced / Typography',
                    },
                    component: () => import('./views/advanced/typography'),
                },
                {
                    path: '/advanced/pricing-tables',
                    meta: {
                        title: 'Advanced / Pricing Tables',
                    },
                    component: () => import('./views/advanced/pricing-tables'),
                },
                {
                    path: '/advanced/invoice',
                    meta: {
                        title: 'Advanced / Invoice',
                    },
                    component: () => import('./views/advanced/invoice'),
                },
                {
                    path: '/advanced/colors',
                    meta: {
                        title: 'Advanced / Colors',
                    },
                    component: () => import('./views/advanced/colors'),
                },
                // Main Menu
                /* {
                  path: '/main-menu/dashboard',
                  meta: {
                    title: i18n.tc('Dashboard'),
                  },
                  component: () => import('./views/main-menu/dashboard'),
                },
                {
                  path: '/main-menu/reports',
                  meta: {
                    title: i18n.tc('Reports'),
                  },
                  component: () => import('./views/main-menu/reports'),
                },
                {
                  path: '/main-menu/find-users',
                  meta: {
                    title: i18n.tc('Find Users'),
                  },
                  component: () => import('./views/main-menu/find-users'),
                },
                {
                  path: '/main-menu/user-info',
                  meta: {
                    title: i18n.tc('User Info'),
                  },
                  component: () => import('./views/main-menu/user-info'),
                },
                {
                  path: '/main-menu/find-groups',
                  meta: {
                    title: i18n.tc('Find Groups'),
                  },
                  component: () => import('./views/main-menu/find-groups'),
                },
                {
                  path: '/main-menu/group-info',
                  meta: {
                    title: i18n.tc('Group Info'),
                  },
                  component: () => import('./views/main-menu/group-info'),
                },
                {
                  path: '/main-menu/leader-board/province',
                  meta: {
                    title: i18n.tc('Province'),
                  },
                  component: () => import('./views/main-menu/leader-board/province'),
                },
                {
                  path: '/main-menu/random-user-names',
                  meta: {
                    title: i18n.tc('Random User Names'),
                  },
                  component: () => import('./views/main-menu/random-user-names'),
                }, */
                {
                    path: '/project-management',
                    meta: {
                        title: i18n.tc('Project Management'),
                    },
                    component: () => import('./views/project-management'),
                },
                {
                    path: '/add-or-edit-project',
                    meta: {
                        title: i18n.tc('Add or Edit Project'),
                    },
                    component: () => import('./views/add-or-edit-project'),
                },
                {
                    path: '/user-management',
                    name: 'user-management',
                    meta: {
                        title: i18n.tc('User Management'),
                    },
                    component: () => import('./views/user-management'),
                },
                {
                    path: '/report/procurement',
                    meta: {
                        title: i18n.tc('Procurement Report'),
                    },
                    component: () => import('./views/report/procurement'),
                },
                {
                    path: '/report/contract-management',
                    meta: {
                        title: i18n.tc('Contract Management Report'),
                    },
                    component: () => import('./views/report/contract-management'),
                },
                {
                    path: '/report/disbursement-result',
                    meta: {
                        title: i18n.tc('Disbursement Result Report'),
                    },
                    component: () => import('./views/report/disbursement-result'),
                },
                {
                    path: '/user-management/create',
                    name: 'user-management.create',
                    meta: {
                        title: i18n.tc('User Management'),
                    },
                    component: () => import('./views/user-management/form'),
                },
                {
                    path: '/user-management/:id',
                    name: 'user-management.edit',
                    meta: {
                        title: i18n.tc('User Management'),
                    },
                    component: () => import('./views/user-management/form'),
                },
                {
                    path: '/division-management',
                    meta: {
                        title: i18n.tc('Division Management'),
                    },
                    component: () => import('./views/division-management'),
                },
                {
                    path: '/division-management/:id',
                    name: 'division-management.userForm',
                    meta: {
                        title: i18n.tc('Division Management'),
                    },
                    component: () => import('./views/division-management/userForm'),
                },
                {
                    path: '/basic-info/procurement-type',
                    meta: {
                        title: i18n.tc('Procurement Type Info'),
                    },
                    component: () => import('./views/basic-info/procurement-type'),
                },
                {
                    path: '/basic-info/procurement-type/:id',
                    name: 'procurement-type.procurementStepTable',
                    meta: {
                        title: i18n.tc('Procurement Type Info'),
                    },
                    component: () => import('./views/basic-info/procurement-type/procurementStepTable'),
                },
                {
                    path: '/basic-info/inspection-type',
                    meta: {
                        title: i18n.tc('Inspection Type Info'),
                    },
                    component: () => import('./views/basic-info/inspection-type'),
                },
                {
                    path: '/basic-info/inspection-type/:id',
                    name: 'inspection-type.inspectionStepDataTable',
                    meta: {
                        title: i18n.tc('Inspection Type Info'),
                    },
                    component: () => import('./views/basic-info/inspection-type/inspectionStepDataTable'),
                },
                {
                    path: '/basic-info/plan',
                    meta: {
                        title: i18n.tc('Plan Info'),
                    },
                    component: () => import('./views/basic-info/plan'),
                },
                // {
                //   path: '/basic-info/holiday',
                //   meta: {
                //     title: i18n.tc('Holiday Info'),
                //   },
                //   component: () => import('./views/basic-info/holiday'),
                // },
                {
                    path: '/basic-info/vendor',
                    meta: {
                        title: i18n.tc('Vendor Info'),
                    },
                    component: () => import('./views/basic-info/vendor'),
                },
                {
                    path: '/role-management',
                    name: 'role-management',
                    meta: {
                        title: i18n.tc('Role Management'),
                    },
                    component: () => import('./views/role-management'),
                },
                {
                    path: '/role-management/:id',
                    name: 'role-management.permissionForm',
                    meta: {
                        title: i18n.tc('Role Management'),
                    },
                    component: () => import('./views/role-management/permissionForm'),
                },
                {
                    path: '/config-notify',
                    name: 'config-notify',
                    meta: {
                        title: i18n.tc('Config Notify'),
                    },
                    component: () => import('./views/config-notify'),
                },
                {
                    path: '/user-info',
                    name: 'user-info',
                    meta: {
                        title: i18n.tc('User Info'),
                    },
                    component: () => import('./views/user-info'),
                },
                /* {
                  path: '/intro',
                  meta: {
                    title: i18n.tc('Intro'),
                  },
                  component: () => import('./views/intro'),
                }, */
            ],
        },
        // System Pages
        {
            path: '/auth',
            component: AuthLayout,
            redirect: 'auth/login',
            children: [
                {
                    path: '/auth/404',
                    meta: {
                        title: 'Error 404',
                    },
                    component: () => import('./views/auth/404'),
                },
                {
                    path: '/auth/500',
                    meta: {
                        title: 'Error 500',
                    },
                    component: () => import('./views/auth/500'),
                },
                {
                    path: '/auth/login',
                    meta: {
                        title: 'Sign In',
                    },
                    component: () => import('./views/auth/login'),
                    /* props: (route) => ({ query: route.query.code }), */
                    /* props: (route) => console.log('route -->', route), */
                },
                {
                    path: '/auth/register',
                    meta: {
                        title: 'Sign Up',
                    },
                    component: () => import('./views/auth/register'),
                },
                {
                    path: '/auth/forgot-password',
                    meta: {
                        title: 'Forgot Password',
                    },
                    component: () => import('./views/auth/forgot-password'),
                },
                {
                    path: '/auth/lockscreen',
                    meta: {
                        title: 'Lockscreen',
                    },
                    component: () => import('./views/auth/lockscreen'),
                },
            ],
        },
        // Public Reports
        {
            path: '/public',
            component: PublicLayout,
            redirect: 'public/summary',
            children: [
                {
                    path: '/public/summary',
                    meta: {
                        title: i18n.tc('Reports'),
                    },
                    component: () => import('./views/main-menu/reports'),
                },
            ],
        },
        // Public Page
        {
            path: '/',
            component: CustomPublicLayout,
            redirect: '/',
            meta: {
                publicRequired: true,
                hidden: true,
            },
            children: [
                {
                    path: '/sms/reward/:member_id/:priv_id',
                    meta: {
                        title: i18n.tc('SMS Reward'),
                    },
                    component: () => import('./views/sms-reward'),
                },
                {
                    path: '/sms/reward/condition/:member_id/:priv_id_from_sms/:priv_id',
                    meta: {
                        title: i18n.tc('SMS Reward condition'),
                    },
                    component: () => import('./views/sms-reward/reward-condition'),
                },
                {
                    path: '/sms/reward/use/:member_id/:priv_id_from_sms/:priv_id',
                    meta: {
                        title: i18n.tc('SMS Reward Use'),
                    },
                    component: () => import('./views/sms-reward/use-reward'),
                },
                {
                    path: '/sms/reward/code/:member_id/:priv_id_from_sms/:priv_id',
                    meta: {
                        title: i18n.tc('SMS Reward Use'),
                    },
                    component: () => import('./views/sms-reward/code-reward'),
                },
                // Password Ticket
                {
                    path: '/share/ticket/:key',
                    meta: {
                        title: i18n.tc('Password Ticket'),
                    },
                    component: () => import('./views/password-ticket'),
                },
                // Ticket Layout 1
                {
                    path: '/ticket-layout-1',
                    meta: {
                        title: i18n.tc('Ticket Layout 1'),
                    },
                    component: () => import('./views/ticket-layout-1'),
                },
                // Ticket Layout 2
                {
                    path: '/ticket-layout-2',
                    meta: {
                        title: i18n.tc('Ticket Layout 2'),
                    },
                    component: () => import('./views/ticket-layout-2'),
                },
                // Ticket Layout 3
                {
                    path: '/ticket-layout-3',
                    meta: {
                        title: i18n.tc('Ticket Layout 3'),
                    },
                    component: () => import('./views/ticket-layout-3'),
                },
                // Download
                {
                    path: '/download',
                    meta: {
                        title: i18n.tc('Download'),
                    },
                    component: () => import('./views/download'),
                },
                // https://debentureclub-dev.scg.com/share/reward/a9b4ec2eb4ab7b1b9c3392bb5388119d
                {
                    path: '/share/reward/:key',
                    meta: {
                        title: i18n.tc('Share Reward'),
                    },
                    component: () => import('./views/share-reward'),
                },
                // https://debentureclub-dev.scg.com/share/reward/a9b4ec2eb4ab7b1b9c3392bb5388119d
                {
                    path: '/password/reward/:key',
                    meta: {
                        title: i18n.tc('Password Reward'),
                    },
                    component: () => import('./views/password-reward'),
                },
                // Reward Code Guest
                {
                    path: '/reward-code/guest',
                    meta: {
                        title: i18n.tc('Reward Code'),
                    },
                    component: () => import('./views/reward-code-guest'),
                },
                // Debenture Banners
                {
                    path: '/debenture-banners',
                    meta: {
                        title: i18n.tc('Debenture Banners'),
                    },
                    component: () => import('./views/debenture-banners'),
                },
            ],
        },
        {
            path: '/',
            redirect: '/intro' /* Set Default Page */,
            component: CustomLayout,
            meta: {
                authRequired: true,
                hidden: true,
            },
            children: [
                // Intro
                {
                    path: '/intro',
                    component: CustomLayout,
                    redirect: 'intro',
                    children: [
                        {
                            path: '/intro',
                            meta: {
                                title: i18n.tc('Intro'),
                            },
                            component: () => import('./views/intro'),
                        },
                    ],
                },
                // Home
                {
                    path: '/home',
                    component: CustomLayout,
                    redirect: 'home',
                    children: [
                        {
                            path: '/home',
                            meta: {
                                title: i18n.tc('Home'),
                            },
                            component: () => import('./views/home'),
                        },
                    ],
                },
                // Profile
                {
                    path: '/profile',
                    component: CustomLayout,
                    redirect: 'profile',
                    children: [
                        {
                            path: '/profile',
                            meta: {
                                title: i18n.tc('Profile'),
                            },
                            component: () => import('./views/profile'),
                        },
                    ],
                },
                // Change Password
                {
                    path: '/change-password',
                    component: CustomLayout,
                    redirect: 'change-password',
                    children: [
                        {
                            path: '/change-password',
                            meta: {
                                title: i18n.tc('Change Password'),
                            },
                            component: () => import('./views/change-password'),
                        },
                    ],
                },
                // Contact
                {
                    path: '/contact',
                    component: CustomLayout,
                    redirect: 'contact',
                    children: [
                        {
                            path: '/contact',
                            meta: {
                                title: i18n.tc('Contact'),
                            },
                            component: () => import('./views/contact'),
                        },
                    ],
                },
                {
                    path: '/delete-account',
                    component: CustomLayout,
                    redirect: 'delete-account',
                    children: [
                        {
                            path: '/delete-account',
                            meta: {
                                title: i18n.tc('Delete Account'),
                            },
                            component: () => import('./views/delete-account'),
                        },
                    ],
                },
                // Terms and Conditions
                {
                    path: '/terms-and-conditions',
                    component: CustomLayout,
                    redirect: 'terms-and-conditions',
                    children: [
                        {
                            path: '/terms-and-conditions',
                            meta: {
                                title: i18n.tc('Terms and Conditions'),
                            },
                            component: () => import('./views/terms-and-conditions'),
                        },
                    ],
                },
                // Privacy Policy
                {
                    path: '/privacy-policy',
                    component: CustomLayout,
                    redirect: 'privacy-policy',
                    children: [
                        {
                            path: '/privacy-policy',
                            meta: {
                                title: i18n.tc('Privacy Policy'),
                            },
                            component: () => import('./views/privacy-policy'),
                        },
                    ],
                },
                // Terms
                {
                    path: '/terms',
                    component: CustomLayout,
                    redirect: 'terms',
                    children: [
                        {
                            path: '/terms',
                            meta: {
                                title: i18n.tc('Terms'),
                            },
                            component: () => import('./views/terms'),
                        },
                    ],
                },
                // Method of Use
                {
                    path: '/method-of-use',
                    component: CustomLayout,
                    redirect: 'method-of-use',
                    children: [
                        {
                            path: '/method-of-use',
                            meta: {
                                title: i18n.tc('Method of Use'),
                            },
                            component: () => import('./views/method-of-use'),
                        },
                    ],
                },
                // Edit Profile
                {
                    path: '/my-profile',
                    component: CustomLayout,
                    redirect: 'my-profile',
                    children: [
                        {
                            path: '/my-profile',
                            meta: {
                                title: i18n.tc('Edit Profile'),
                            },
                            component: () => import('./views/my-profile'),
                        },
                    ],
                },
                // Edit Profile
                {
                    path: '/edit-profile',
                    component: CustomLayout,
                    redirect: 'edit-profile',
                    children: [
                        {
                            path: '/edit-profile',
                            meta: {
                                title: i18n.tc('Edit Profile'),
                            },
                            component: () => import('./views/edit-profile'),
                        },
                    ],
                },
                // Edit Profile
                {
                    path: '/edit-address',
                    component: CustomLayout,
                    redirect: 'edit-address',
                    children: [
                        {
                            path: '/edit-address',
                            meta: {
                                title: i18n.tc('Edit Profile'),
                            },
                            component: () => import('./views/edit-address'),
                        },
                    ],
                },
                // Privilege
                {
                    path: '/privilege',
                    component: CustomLayout,
                    redirect: 'privilege',
                    children: [
                        {
                            path: '/privilege',
                            meta: {
                                title: i18n.tc('Privilege'),
                            },
                            component: () => import('./views/privilege'),
                        },
                    ],
                },
                // Privilege Detail
                {
                    path: '/privilege-detail',
                    component: CustomLayout,
                    redirect: 'privilege-detail',
                    children: [
                        {
                            path: '/privilege-detail',
                            meta: {
                                title: i18n.tc('Privilege Detail'),
                            },
                            component: () => import('./views/privilege-detail'),
                        },
                    ],
                },
                // Privilege Detail Uniqueprivilege true
                {
                    path: '/privilege-detail-uniqueprivilegetrue',
                    component: CustomLayout,
                    redirect: 'privilege-detail-uniqueprivilegetrue',
                    children: [
                        {
                            path: '/privilege-detail-uniqueprivilegetrue',
                            meta: {
                                title: i18n.tc('Privilege Detail'),
                            },
                            component: () => import('./views/privilege-detail-uniqueprivilegetrue'),
                        },
                    ],
                },
                // Privilege Detail
                {
                    path: '/privilege-choice',
                    component: CustomLayout,
                    redirect: 'privilege-choice',
                    children: [
                        {
                            path: '/privilege-choice',
                            meta: {
                                title: i18n.tc('Privilege Choice'),
                            },
                            component: () => import('./views/privilege-choice'),
                        },
                    ],
                },
                // Privilege Generate
                {
                    path: '/privilege-generate',
                    component: CustomLayout,
                    redirect: 'privilege-generate',
                    children: [
                        {
                            path: '/privilege-generate',
                            meta: {
                                title: i18n.tc('Privilege Generate'),
                            },
                            component: () => import('./views/privilege-generate'),
                        },
                    ],
                },
                // Debenture
                {
                    path: '/debenture',
                    component: CustomLayout,
                    redirect: 'debenture',
                    children: [
                        {
                            path: '/debenture',
                            meta: {
                                title: i18n.tc('Debenture'),
                            },
                            component: () => import('./views/debenture'),
                        },
                    ],
                },
                {
                    path: '/debenture-final',
                    component: CustomLayout,
                    redirect: 'debenture-final',
                    children: [
                        {
                            path: '/debenture-final',
                            meta: {
                                title: i18n.tc('Debenture Final'),
                            },
                            component: () => import('./views/debenture-final'),
                        },
                    ],
                },
                {
                    path: '/debenture-banklist',
                    component: CustomLayout,
                    redirect: 'debenture-banklist',
                    children: [
                        {
                            path: '/debenture-banklist',
                            meta: {
                                title: i18n.tc('Debenture Banklist'),
                            },
                            component: () => import('./views/debenture-banklist'),
                        },
                    ],
                },
                // Activity
                {
                    path: '/activity',
                    component: CustomLayout,
                    redirect: 'activity',
                    children: [
                        {
                            path: '/activity',
                            meta: {
                                title: i18n.tc('Activity'),
                            },
                            component: () => import('./views/activity'),
                        },
                    ],
                },
                // Activity Detail
                {
                    path: '/activity-detail',
                    component: CustomLayout,
                    redirect: 'activity-detail',
                    children: [
                        {
                            path: '/activity-detail',
                            meta: {
                                title: i18n.tc('Activity Detail'),
                            },
                            component: () => import('./views/activity-detail'),
                        },
                    ],
                },
                // Log
                {
                    path: '/log',
                    component: CustomLayout,
                    redirect: 'log',
                    children: [
                        {
                            path: '/log',
                            meta: {
                                title: i18n.tc('Log'),
                            },
                            component: () => import('./views/log'),
                        },
                    ],
                },
                {
                    path: '/log-activity-fill-detail',
                    component: CustomLayout,
                    redirect: '/log-activity-fill-detail',
                    children: [
                        {
                            path: '/log-activity-fill-detail',
                            meta: {
                                title: i18n.tc('Log Activity Detail'),
                            },
                            component: () => import('./views/log-activity-fill-detail'),
                        },
                    ],
                },
                {
                    path: '/log-activity-data-detail',
                    component: CustomLayout,
                    redirect: '/log-activity-data-detail',
                    children: [
                        {
                            path: '/log-activity-data-detail',
                            meta: {
                                title: i18n.tc('Log Activity Detail'),
                            },
                            component: () => import('./views/log-activity-data-detail'),
                        },
                    ],
                },
                // Reward
                {
                    path: '/reward',
                    component: CustomLayout,
                    redirect: 'reward',
                    children: [
                        {
                            path: '/reward',
                            meta: {
                                title: i18n.tc('Reward'),
                            },
                            component: () => import('./views/reward'),
                        },
                    ],
                },
                // Use Reward
                {
                    path: '/use-reward',
                    component: CustomLayout,
                    redirect: 'use-reward',
                    children: [
                        {
                            path: '/use-reward',
                            meta: {
                                title: i18n.tc('Use Reward'),
                            },
                            component: () => import('./views/use-reward'),
                        },
                    ],
                },
                // Reward Code
                {
                    path: '/reward-code',
                    component: CustomLayout,
                    redirect: 'reward-code',
                    children: [
                        {
                            path: '/reward-code',
                            meta: {
                                title: i18n.tc('Reward Code'),
                            },
                            component: () => import('./views/reward-code'),
                        },
                    ],
                },
                // Reward Code Close
                {
                    path: '/reward-code-close',
                    component: CustomLayout,
                    redirect: 'reward-code-close',
                    children: [
                        {
                            path: '/reward-code-close',
                            meta: {
                                title: i18n.tc('Reward Code Close'),
                            },
                            component: () => import('./views/reward-code-close'),
                        },
                    ],
                },
                // Reward Condition
                {
                    path: '/reward-condition',
                    component: CustomLayout,
                    redirect: 'reward-condition',
                    children: [
                        {
                            path: '/reward-condition',
                            meta: {
                                title: i18n.tc('Reward Condition'),
                            },
                            component: () => import('./views/reward-condition'),
                        },
                    ],
                },
                // Delight
                {
                    path: '/delight',
                    component: CustomLayout,
                    redirect: 'delight',
                    children: [
                        {
                            path: '/delight',
                            meta: {
                                title: i18n.tc('Delight'),
                            },
                            component: () => import('./views/delight'),
                        },
                    ],
                },
                // Delight Detail
                {
                    path: '/delight-detail',
                    component: CustomLayout,
                    redirect: 'delight-detail',
                    children: [
                        {
                            path: '/delight-detail',
                            meta: {
                                title: i18n.tc('Delight Detail'),
                            },
                            component: () => import('./views/delight-detail'),
                        },
                    ],
                },
                // Search
                {
                    path: '/search',
                    component: CustomLayout,
                    redirect: 'search',
                    children: [
                        {
                            path: '/search',
                            meta: {
                                title: i18n.tc('Search'),
                            },
                            component: () => import('./views/search'),
                        },
                    ],
                },
                // Search Detail
                {
                    path: '/search-detail',
                    component: CustomLayout,
                    redirect: 'search-detail',
                    children: [
                        {
                            path: '/search-detail',
                            meta: {
                                title: i18n.tc('Search Detail'),
                            },
                            component: () => import('./views/search-detail'),
                        },
                    ],
                },
                // Log Privilege Detail
                {
                    path: '/log-privilege-detail',
                    component: CustomLayout,
                    redirect: 'log-privilege-detail',
                    children: [
                        {
                            path: '/log-privilege-detail',
                            meta: {
                                title: i18n.tc('Log Privilege Detail'),
                            },
                            component: () => import('./views/log-privilege-detail'),
                        },
                    ],
                },
                // Welcome
                {
                    path: '/welcome',
                    component: CustomLayout,
                    redirect: 'welcome',
                    children: [
                        {
                            path: '/welcome',
                            meta: {
                                title: i18n.tc('Welcome'),
                            },
                            component: () => import('./views/welcome'),
                        },
                    ],
                },
                // Popup
                {
                    path: '/popup',
                    component: CustomLayout,
                    redirect: 'popup',
                    children: [
                        {
                            path: '/popup',
                            meta: {
                                title: i18n.tc('Popup'),
                            },
                            component: () => import('./views/popup'),
                        },
                    ],
                },
                // Out of Service
                {
                    path: '/out-of-service',
                    component: CustomLayout,
                    redirect: 'out-of-service',
                    children: [
                        {
                            path: '/out-of-service',
                            meta: {
                                title: i18n.tc('Out of Service'),
                            },
                            component: () => import('./views/out-of-service'),
                        },
                    ],
                },
                // Log Activity Follower
                {
                    path: '/log-activity-follower',
                    component: CustomLayout,
                    redirect: 'log-activity-follower',
                    children: [
                        {
                            path: '/log-activity-follower',
                            meta: {
                                title: i18n.tc('Log Activity Follower'),
                            },
                            component: () => import('./views/log-activity-follower'),
                        },
                    ],
                },
                // Log Activity Follower Detail
                {
                    path: '/log-activity-follower-detail',
                    component: CustomLayout,
                    redirect: 'log-activity-follower-detail',
                    children: [
                        {
                            path: '/log-activity-follower-detail',
                            meta: {
                                title: i18n.tc('Log Activity Follower Detail'),
                            },
                            component: () => import('./views/log-activity-follower-detail'),
                        },
                    ],
                },
                // Inbox
                {
                    path: '/inbox',
                    component: CustomLayout,
                    redirect: 'inbox',
                    children: [
                        {
                            path: '/inbox',
                            meta: {
                                title: i18n.tc('Inbox'),
                            },
                            component: () => import('./views/inbox'),
                        },
                    ],
                },
                // Inbox Detail
                {
                    path: '/inbox-detail',
                    component: CustomLayout,
                    redirect: 'inbox-detail',
                    children: [
                        {
                            path: '/inbox-detail',
                            meta: {
                                title: i18n.tc('Inbox Detail'),
                            },
                            component: () => import('./views/inbox-detail'),
                        },
                    ],
                },
                // Favorite
                {
                    path: '/favorite',
                    component: CustomLayout,
                    redirect: 'favorite',
                    children: [
                        {
                            path: '/favorite',
                            meta: {
                                title: i18n.tc('Favorite'),
                            },
                            component: () => import('./views/favorite'),
                        },
                    ],
                },
                // Favorite Detail
                {
                    path: '/favorite-detail',
                    component: CustomLayout,
                    redirect: 'favorite-detail',
                    children: [
                        {
                            path: '/favorite-detail',
                            meta: {
                                title: i18n.tc('Favorite Detail'),
                            },
                            component: () => import('./views/favorite-detail'),
                        },
                    ],
                },
                // Ticket
                {
                    path: '/ticket',
                    component: CustomLayout,
                    redirect: 'ticket',
                    children: [
                        {
                            path: '/ticket',
                            meta: {
                                title: i18n.tc('Ticket'),
                            },
                            component: () => import('./views/ticket'),
                        },
                    ],
                },
                // Ticket Activity Detail
                {
                    path: '/ticket-activity-detail',
                    component: CustomLayout,
                    redirect: 'ticket-activity-detail',
                    children: [
                        {
                            path: '/ticket-activity-detail',
                            meta: {
                                title: i18n.tc('Ticket Activity Detail'),
                            },
                            component: () => import('./views/ticket-activity-detail'),
                        },
                    ],
                },
                // Ticket List
                {
                    path: '/ticket-list',
                    component: CustomLayout,
                    redirect: 'ticket-list',
                    children: [
                        {
                            path: '/ticket-list',
                            meta: {
                                title: i18n.tc('Ticket List'),
                            },
                            component: () => import('./views/ticket-list'),
                        },
                    ],
                },
                // Ticket Info
                {
                    path: '/ticket-info',
                    component: CustomLayout,
                    redirect: 'ticket-info',
                    children: [
                        {
                            path: '/ticket-info',
                            meta: {
                                title: i18n.tc('Ticket Info'),
                            },
                            component: () => import('./views/ticket-info'),
                        },
                    ],
                },
                // Ticket Attach
                {
                    path: '/ticket-attach',
                    component: CustomLayout,
                    redirect: 'ticket-attach',
                    children: [
                        {
                            path: '/ticket-attach',
                            meta: {
                                title: i18n.tc('Ticket Attach'),
                            },
                            component: () => import('./views/ticket-attach'),
                        },
                    ],
                },
                // Doc List
                {
                    path: '/doc-list',
                    component: CustomLayout,
                    redirect: 'doc-list',
                    children: [
                        {
                            path: '/doc-list',
                            meta: {
                                title: i18n.tc('Doc List'),
                            },
                            component: () => import('./views/doc-list'),
                        },
                    ],
                },
                // Doc Info
                {
                    path: '/doc-info',
                    component: CustomLayout,
                    redirect: 'doc-info',
                    children: [
                        {
                            path: '/doc-info',
                            meta: {
                                title: i18n.tc('Doc Info'),
                            },
                            component: () => import('./views/doc-info'),
                        },
                    ],
                },
                // Ticket System Report
                {
                    path: '/ticket-system-report',
                    component: CustomLayout,
                    redirect: 'ticket-system-report',
                    children: [
                        {
                            path: '/ticket-system-report',
                            meta: {
                                title: i18n.tc('Ticket System Report'),
                            },
                            component: () => import('./views/ticket-system-report'),
                        },
                    ],
                },
                // Ticket System Report Create
                {
                    path: '/ticket-system-report-create',
                    component: CustomLayout,
                    redirect: 'ticket-system-report-create',
                    children: [
                        {
                            path: '/ticket-system-report-create',
                            meta: {
                                title: i18n.tc('Ticket System Report Create'),
                            },
                            component: () => import('./views/ticket-system-report-create'),
                        },
                    ],
                },
                // Ticket System Report Detail
                {
                    path: '/ticket-system-report-detail',
                    component: CustomLayout,
                    redirect: 'ticket-system-report-detail',
                    children: [
                        {
                            path: '/ticket-system-report-detail',
                            meta: {
                                title: i18n.tc('Ticket System Report Detail'),
                            },
                            component: () => import('./views/ticket-system-report-detail'),
                        },
                    ],
                },
            ],
        },
        // Redirect to 404
        {
            path: '*',
            redirect: 'auth/404',
            hidden: true,
        },
    ],
});
router.beforeEach((to, from, next) => {
    const accessToken = localStorage.getItem('accessToken');
    if (to && to.query && to.query.code) localStorage.setItem('code', to.query.code);
    if (from && from.query && from.query.code) localStorage.setItem('code', from.query.code);
    to.matched.some((record) => console.log('record.meta.authRequired--->', record));
    console.log(
        'to.matched.some((record) => record.meta.authRequired)',
        to.matched.some((record) => record.meta.authRequired)
    );
    if (to.matched.some((record) => record.meta.authRequired)) {
        if (!accessToken) {
            console.log('!accessToken');
            next({
                path: '/auth/login',
                query: { redirect: to.fullPath },
            });
        } else {
            console.log('accessToken');
            next();
        }
    } else if (to.matched.some((record) => record.meta.publicRequired)) {
        next();
    } else {
        if (accessToken) {
            next({
                path: '/home',
                query: { redirect: to.fullPath },
            });
        } else {
            next();
        }
    }
});
export default router;
